var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('li',[_c('div',{staticClass:"color_square",style:(_vm.backgroudColor)}),_vm._v(" "+_vm._s(_vm.stateString)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }